'use strict';

exports.__esModule = true;
var MODEL_CACHE_UPDATED = exports.MODEL_CACHE_UPDATED = 'VIAS_MODEL_CACHE_UPDATED';
var SECOND = exports.SECOND = 1000;
var MINUTE = exports.MINUTE = 60 * SECOND;
var HOUR = exports.HOUR = 60 * MINUTE;
var FOREVER = exports.FOREVER = -1;

var DOCUMENT_SHAPE = exports.DOCUMENT_SHAPE = function () {
  return null;
};
var OBJECT_SHAPE = exports.OBJECT_SHAPE = function (result) {
  var paths = [];
  for (var key in result) {
    if (result.hasOwnProperty(key)) {
      paths.push(key);
    }
  }
  return paths;
};

var ARRAY_SHAPE = exports.ARRAY_SHAPE = OBJECT_SHAPE;


//////////////////
// WEBPACK FOOTER
// ./~/vias/lib/constants.js
// module id = 229
// module chunks = 15